module.exports = __webpack_public_path__ + "img/debate2023.254ba12d.jpg";